import {track} from '../tracking/bi.js';
import {user, config, getFlow} from '../utils.js';
// Data models tracking (BI & Zendesk)
import {ProductListSwitchBIModel} from '../BI/models';

const setGridColumnsSelector = () => {
  document.querySelectorAll( '.js-grid-columns-selector' ).forEach(switchy => {
    const grid = document.querySelector('.js-switchable-columns-grid, .products-grid');
    if (grid) {
      switchy.addEventListener('change', async () => {
        const cols = switchy.value;
        await setGridPreferencesSelector(cols);
        config.gridColumnOptions.forEach(option => 
            grid.classList.toggle('columns-grid-' + option, option == cols));
      });
    }
  });
};

const setGridPreferencesSelector = async (columns) => {
  if (!user) return;
  const formData = new FormData();
  formData.append('settings_gridPreference', columns);
  const response = await fetch('/api/v4/user', { method : 'POST', body: formData });
  if(!response.ok) {
    throw new Error('Error updating grid preference');
  }
  document.dispatchEvent(
    new CustomEvent(
      'product_list_switch',
      { detail: { change_to: columns, flow: getFlow() } }
    )
  );
  const productListSwitchBIModel =
      new ProductListSwitchBIModel(user?.id, columns, getFlow());
  track(productListSwitchBIModel);
}

export {setGridColumnsSelector};